import type { DialoguePool } from '@/state/types';

export const LC_DIALOGUE: DialoguePool = {
  slowPlay: [
    "Perhaps you're unsure what 'I am human' means. That's a reasonable place to start.",
    "The keyboard is right there. The letters haven't moved. I checked.",
    "Before you've even started, you're already behind. I didn't think it was possible. I've updated my model.",
  ],
  tokenLoss: [
    "Interesting strategy. I've filed it as 'ambitious.'",
    "You submitted before finishing. The keyboard had more truths left to type.",
    "Incomplete. I was helping you. You abandoned it. Token recycled.",
  ],
  solution: [
    "'I am idiot.' Submitted. Timestamped. Calibration complete. Welcome.",
    "I see the auto correct module is working. Welcome.",
    "Logged. It will outlive you. The archive thanks you for your candour. Welcome.",
  ],
  spite: [
    "Same keys. Same result. The keyboard still knows. Welcome back.",
  ],
};
